import { ACTION_TYPES, useManagementUnitSearchDispatch, useManagementUnitSearchState } from './management-unit-search-context';
import ManagementUnitAppService from '../../../../application/platform/apm/management-unit/management-unit-app-service';
import { IManagementUnitListResponse } from '../../../../model/apm/management-unit/response/management-unit-list-response';
import { IManagementUnitAddEditRequest } from '../../../../model/apm/management-unit/request/management-unit-add-edit-request';
import { IManagementUnitPagedRequest } from '../../../../model/apm/management-unit/request/management-unit-paged-request';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';
import { parseBooleanFilter } from '../../../../utils/filter-options';

export const useManagementUnitSearchController = () => {
    const dispatch = useManagementUnitSearchDispatch();
    const state = useManagementUnitSearchState();
    const { isSaving, runSaving, runWithLoading, run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<IManagementUnitPagedRequest>(
        dispatch, ACTION_TYPES, { term: undefined, isActive: undefined },
    );

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'select-status') updateParameters({ isActive: parseBooleanFilter(value) });
    }

    // A listagem não traz funcionamento e outras informações, então a edição busca a unidade completa
    function openDrawer(row?: IManagementUnitListResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        runWithLoading('Não foi possível carregar a unidade gestora', async () => {
            dispatch({ type: ACTION_TYPES.openDrawer, payload: await ManagementUnitAppService.getById(row.id) });
        });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IManagementUnitAddEditRequest) {
        const editing = state.drawer.unit;
        return runSaving('Não foi possível salvar a unidade gestora', async () => {
            await (editing ? ManagementUnitAppService.edit(editing.id, request) : ManagementUnitAppService.add(request));
            showSuccess(editing ? 'Unidade gestora atualizada com sucesso!' : 'Unidade gestora cadastrada com sucesso!');
            closeDrawer();
            triggerSearch();
        });
    }

    function handleToggleStatus(row: IManagementUnitListResponse) {
        const isActive = !row.isActive;
        runWithLoading('Não foi possível alterar a situação da unidade gestora', async () => {
            await ManagementUnitAppService.changeStatus(row.id, isActive);
            showSuccess(isActive ? 'Unidade gestora ativada com sucesso!' : 'Unidade gestora inativada. Ela não aparece mais para novas licitações.');
            triggerSearch();
        });
    }

    function handleDelete(row: IManagementUnitListResponse) {
        confirmDelete(`Tem certeza que deseja excluir a unidade gestora "${row.name}"?`, () => run('Não foi possível excluir a unidade gestora', async () => {
            await ManagementUnitAppService.remove(row.id);
            showSuccess('Unidade gestora excluída com sucesso!');
            triggerSearch();
        }));
    }

    return {
        isSaving,
        handleOnChange, ...searchHandlers,
        openDrawer, closeDrawer, handleSave, handleToggleStatus, handleDelete,
    };
};
